import liff from '@line/liff';

export interface LiffInitializer {
  init(config: { liffId: string }): Promise<void>;
}

export type LiffInitializationResult = 'initialized' | 'skipped';

export async function initializeLiff(
  liffId: string | undefined,
  sdk: LiffInitializer = liff,
): Promise<LiffInitializationResult> {
  const normalizedId = String(liffId ?? '').trim();
  if (!normalizedId) return 'skipped';
  await sdk.init({ liffId: normalizedId });
  return 'initialized';
}
